export const Geos = {
  state: () => ({
    data: []
  })
}
